import {React, observer} from '@api'
import {DrawShape, useTldrawApp} from '@modules/whiteboard'

export const DrawIndicator = observer<{shape: DrawShape}>(function DrawIndicator({shape}) {
  const {shapeComponentStores} = useTldrawApp(),
    {bounds, solidPath} = shapeComponentStores[shape.id]

  const verySmall = bounds.width < 4 && bounds.height < 4

  if (verySmall) {
    return <circle x={bounds.width / 2} y={bounds.height / 2} r={1}/>
  }

  return <path d={solidPath}/>
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/shapes/draw/DrawIndicator.tsx